import { createFeatureSelector, createSelector } from "@ngrx/store";
import { EmailNotificationSettingsState } from "./email-notification-settings.reducers";

export const selectEmailNotificationSettingsState =
    createFeatureSelector<EmailNotificationSettingsState>(
        "emailNotificationSettings",
    );

export const selectEmailNotificationSettings = createSelector(
    selectEmailNotificationSettingsState,
    (state) => state.settings,
);

export const selectEmailNotificationSettingsLoading = createSelector(
    selectEmailNotificationSettingsState,
    (state) => state.loading,
);

export const selectEmailNotificationSettingsError = createSelector(
    selectEmailNotificationSettingsState,
    (state) => state.error,
);

export const selectEmailNotificationSettingsUpdatingEventCode = createSelector(
    selectEmailNotificationSettingsState,
    (state) => state.updatingEventCode,
);
